import hasClientData from '@clearscore/helpers.has-client-data';

import getAuth from './auth';

/**
 * add auth headers to provided action and return action
 * @param {object} action redux action
 * @param {object} store redux store
 * @returns {object} action redux action
 */
function _addHeaders(action, store) {
    const {
        payload: { request },
    } = action;

    request.headers = {
        ...request.headers,
        ...getAuth(request.client, store),
    };
    return action;
}

/**
 * If the action payload has a client object, add the correct client auth headers.
 * If no client matches, fallback to the default client
 * @param {object} action redux action
 * @param {object} store redux store
 * @returns {function} function that takes an action and returns an action
 */
const addAuthHeaders = (store) => (action) => (hasClientData(action) ? _addHeaders(action, store) : action);

export default addAuthHeaders;
